import React from 'react';
import { keyframes } from '@emotion/react';
import { Avatar, AvatarProps, Box } from '@mui/material';
import { GEMMA_ICON_URL } from '../../constants/gemmaIcon';

/** Osobny obiekt keyframes (Emotion) — w sx zagnieżdżonym w IconButton nazwa string + @keyframes bywa niespójna. */
const gemmaIconRotateKf = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

type Props = Omit<AvatarProps, 'src' | 'children'> & {
  size?: number;
  /** Domyślnie true — ciągła rotacja wokół środka ikony. W listach wielu wiadomości ustaw `false`. */
  spin?: boolean;
};

/**
 * Ikona Gemmy przez URL z bundla (jak GEMMA_ICON_URL) — bez wielokrotnego wklejania tego samego SVG w DOM.
 * ReactComponent z gradientami/clipPath powielałby te same id (`g1`, `ic`); wtedy `url(#g1)` trafia w pierwszy defs
 * i ikony bywają puste aż do przebudowy (np. po kliknięciu obok tekstu „Gemma”).
 */
export default function GemmaAvatar({ size = 20, sx, spin = true, ...rest }: Props) {
  const dim = typeof size === 'number' ? size : 20;
  return (
    <Avatar
      {...rest}
      src={undefined}
      alt="Gemma"
      sx={{
        width: dim,
        height: dim,
        bgcolor: 'transparent',
        '& .MuiAvatar-img': { objectFit: 'contain' },
        /* Obrót korzenia Avatar (nie inner img): stabilniejsze w IconButton niż transform na img w środku. */
        ...(spin && {
          animation: `${gemmaIconRotateKf} 6.67s linear infinite`,
          transformOrigin: 'center center',
          '@media (prefers-reduced-motion: reduce)': {
            animation: 'none',
          },
        }),
        ...sx,
      }}
    >
      <Box
        component="img"
        src={GEMMA_ICON_URL}
        alt=""
        width={dim}
        height={dim}
        sx={{
          display: 'block',
          objectFit: 'contain',
        }}
        aria-hidden
      />
    </Avatar>
  );
}
